/**
 * Constants and default configuration for BaseModal
 */

    // Focusable elements selector
export const FOCUSABLE_ELEMENTS = [
        'a[href]',
        'area[href]',
        'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
        'select:not([disabled]):not([aria-hidden])',
        'textarea:not([disabled]):not([aria-hidden])',
        'button:not([disabled]):not([aria-hidden])',
        'iframe',
        'object',
        'embed',
        '[contenteditable]',
        '[tabindex]:not([tabindex^="-"])'
    ];

// Default configuration
export const DEFAULT_CONFIG = {
    targetModal        :'',
    triggers           :[],
    openTrigger        :'data-bm-modal-trigger',
    closeTrigger       :'data-bm-modal-close',
    openClass          :'is-open',
    disableScroll      :true,
    disableFocus       :false,
    backFocus          :true,
    awaitCloseAnimation:false,
    awaitOpenAnimation :false,
    disableEsc         :false,
    debugMode          :false,
    allowNested        :true,
    autoClose          :false,
    autoCloseDelay     :3000,
    size               :'default',
    dragToDismiss      :false,
    dragThreshold      :100,
    lazyLoad           :false,
    contentUrl         :'',
    onShow             :() => {
    },
    onClose            :() => {
    },
    onContentLoaded    :() => {
    },
    position           :'center',
    keyboardShortcuts  :{},
    beforeShow         :[],
    beforeClose        :[],
    theme              :'light',
    animation          :'fade',
    swipeNavigation    :false,
    onSwipeLeft        :() => {
    },
    onSwipeRight       :() => {
    },
    hapticFeedback     :false,
    pullToRefresh      :false,
    onRefresh          :() => {
    }
};

// Modal stack for nested modals
export const modalStack = [];
